module.exports = __webpack_public_path__ + "img/salon.cacd6297.svg";